import { render, staticRenderFns } from "./secure.vue?vue&type=template&id=52dbb572&scoped=true"
import script from "./secure.vue?vue&type=script&lang=js"
export * from "./secure.vue?vue&type=script&lang=js"
import style0 from "./secure.vue?vue&type=style&index=0&id=52dbb572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dbb572",
  null
  
)

export default component.exports